<table class="table dense center">
	<thead>
		<tr>
			<th class="avatar-cell">
				@if (isSelectAllDisplayed()) {
					<input
						type="checkbox"
						class="checkbox"
						id="selectAllItems"
						(change)="onSelectAllToggled()"
						[(ngModel)]="allSelected"
					/>
				}
				@if (isSelectAllDisplayed()) {
					<label for="selectAllItems" title="{{ getSelectCheckboxTitle() }}"></label>
				}
			</th>
			@for (column of columns(); track column) {
				<th
					(click)="column.sortable && sort(column.name)"
					[class.visible-gt-small]="column.optional"
					[ngClass]="column.columnClass"
				>
					<span [ngClass]="{ clickable: column.sortable }"
						>{{ columnNamePrefix() + column.name | translate }}
						@if (column.sortable && isSortedBy(column, 1)) {
							<i class="ico sort-icon ico-chevron-up"></i>
						}
						@if (column.sortable && isSortedBy(column, 2)) {
							<i class="ico sort-icon ico-chevron-down"></i>
						}
					</span>
				</th>
			}
		</tr>
	</thead>
	@if (isDisplayingMessageWhenEmpty()) {
		<tbody>
			<tr>
				<td class="avatar-cell"></td>
				<td [attr.colspan]="columns().length" class="empty-content">
					<span translate="{{ translateNone() }}"></span>
				</td>
			</tr>
		</tbody>
	}
	@if (!isDisplayingMessageWhenEmpty()) {
		<tbody>
			@for (item of items(); track item) {
				<tr [ngClass]="{ disabled: rowProvider(item).disabled }">
					<td class="avatar-cell">
						@if (rowProvider(item).checkItem) {
							<input
								type="checkbox"
								class="checkbox"
								id="{{ rowProvider(item).id }}"
								(change)="onSelect()"
								[(ngModel)]="selection.set[rowProvider(item).id]"
								[disabled]="rowProvider(item).disabled"
							/>
						}
						@if (rowProvider(item).checkItem) {
							<label for="{{ rowProvider(item).id }}"></label>
						}
						@if (!rowProvider(item).checkItem) {
							<i
								class="ico"
								[ngClass]="getRowIconClasses(item)"
								(click)="isClickHandled(item) && itemClicked.emit(item)"
							>
							</i>
						}
					</td>
					@for (column of columns(); track column; let index = $index) {
						<td [class.visible-gt-small]="column.optional">
							<span
								class="icon-name"
								(click)="isClickHandled(item) && itemClicked.emit(item)"
								[ngClass]="{ clickable: isClickHandled(item) }"
							>
								{{ cellProvider()(item, index).text }}
							</span>
						</td>
					}
				</tr>
			}
		</tbody>
	}
</table>
